define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/heading/Ref",
	"csi/xml",
	"csi/xml/Query",
	"./_StyleAndColorwayMixin"
], function(declare,lang,csi,Action,ViewRef,Ref,xml,Query,_StyleAndColorwayMixin) {

	return declare([Ref, _StyleAndColorwayMixin], {

		isTabStop: function(/*Context*/ctx, /*Heading*/h) {
			// summary: skip over AggregateInline actions where only dialog is allowed
			return ctx.getNode().StyleCandidates.length > 0;
		},

		_getRenderAction: function(/*Context*/ctx, /*Heading*/h) {
			// summary: action will be used for tooltip
			var	ad = this.inherited(arguments);
			if (ad) {
				ad.bTooltip = !this.isTabStop(ctx, h);
			}

			return ad;
		},

		_getStoreAction: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return Action including ViewRef and optionally Filter and FilterView to select defaults
			var productVersion = ctx.getNode();
			var season = ctx.cache.getNode(productVersion.Season);
			var apparelSeason = season && ctx.cache.getNode(season.ApparelSeason);

			// DE20778
			var query = new Query().Attr("Active", xml.OP_EQUALS, true).RefAttr("StyleMPV", xml.OP_EQUALS, csi.EMPTY_URL);
			var filters = new Query();
			if (apparelSeason) {
				filters.Attr(xml.ATTR_NAME, xml.OP_EQUALS, apparelSeason.$Name, "Child:ParentSeason");
			}

			let viewRef = lang.mixin(new ViewRef(), {
					m_id: "AllStyles",
					m_url: "centric://APPAREL/Views"
				});
			if (this.isTabStop(ctx, h)) {
				viewRef = lang.mixin(new ViewRef(), {
						m_id: "StyleCandidates"
					})
			}

			return lang.mixin(new Action(), {
				m_filtersView: filters.getElements(),
				m_fixedQuery: query,
				m_viewRef: viewRef
			});

		}
	});
});